<template>
  <modal
    :title="$t('title')"
    @hidden="onHidden"
    @shown="focusPrimaryInput"
    class="publication-form"
    playground
    ref="modal"
  >
    <form @submit.prevent="submit">
      <div class="uk-modal-body">
        <validation-alert-box :errors="fields.errors.base" />

        <tenant-combobox
          :disabled="!isEditable"
          :errors="fields.errors.tenant"
          :label="$t('fields.tenant')"
          v-model="fields.values.tenant"
        />

        <checkbox
          :disabled="!isEditable"
          :errors="fields.errors.list"
          :label="$t('fields.list')"
          @change="toggleOrdered"
          ref="primaryInput"
          v-model="fields.values.list"
        />

        <template v-if="fields.values.list">
          <radio-group-input
            :collection="availablePositionModes"
            :disabled="!isEditable"
            :inline="false"
            :label="$t('fields.positionMode')"
            @change="setPosition"
            v-model="positionMode"
          />

          <text-input
            :disabled="!isEditable"
            :errors="fields.errors.position"
            :label="$t('fields.position')"
            class="uk-width-1-4"
            type="number"
            v-if="customPositionable"
            v-model.number="fields.values.position"
          />
        </template>
      </div>

      <div class="uk-modal-footer uk-text-right">
        <submit-button :disabled="!isSubmittable" type="primary" />
        <common-button @click="hide">{{$t('actions.cancel')}}</common-button>
      </div>
    </form>
  </modal>
</template>

<script>
import CancelButton from '@/components/CancelButton';
import Checkbox from '@/components/Checkbox';
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/Form';
import Modal from '@/components/Modal';
import RadioGroupInput from '@/components/RadioGroupInput';
import SubmitButton from '@/components/SubmitButton';
import TenantCombobox from '@/components/TenantCombobox';
import TextInput from '@/components/TextInput';
import ValidationAlertBox from '@/components/ValidationAlertBox';

const POSITION_MODES = ['none', 'top', 'bottom', 'custom'];

export default {
  name: 'publication-form',
  mixins: [
    Form({
      tenant: {
        loadErrorsFrom: false,
        required: true,
        validate: [
          function validatePublicationNotExists(value, field, values) {
            let isValid = true;
            if (values.tenant && !this.values) {
              isValid = !this.publications.find(p =>
                p.tenant && p.tenant.id === values.tenant.id);
            }

            return {
              isValid,
              message: this.$t('validationErrors.publicationTaken'),
            };
          },
        ],
      },
      list: { default: false },
      position: true,
    }),
  ],
  components: {
    CancelButton,
    Checkbox,
    CommonButton,
    Modal,
    RadioGroupInput,
    SubmitButton,
    TenantCombobox,
    TextInput,
    ValidationAlertBox,
  },
  props: {
    publications: Array,
  },
  data() {
    return { positionMode: POSITION_MODES[0] };
  },
  computed: {
    customPositionable() {
      return this.positionMode === 'custom';
    },
    availablePositionModes() {
      return POSITION_MODES.map(positionMode => ({
        label: this.$t(`positionModes.${positionMode}`),
        value: positionMode,
      }));
    },
  },
  methods: {
    async show() {
      this.$refs.modal.show();
      await this.$nextTick();

      switch (this.fields.values.position) {
        case 1:
          this.positionMode = 'top';
          break;
        case -1:
          this.positionMode = 'bottom';
          break;
        case null:
          this.positionMode = 'none';
          break;
        default:
          this.positionMode = 'custom';
          break;
      }
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      this.resetToDefaults();
      this.$emit('hidden');
    },
    focusPrimaryInput() {
      this.$refs.primaryInput.focus();
    },
    toggleOrdered() {
      if (!this.fields.values.list) {
        this.positionMode = POSITION_MODES[0];
        this.fields.values.position = null;
      }
    },
    setPosition() {
      switch (this.positionMode) {
        case 'none':
          this.fields.values.position = null;
          break;
        case 'top':
          this.fields.values.position = 1;
          break;
        case 'bottom':
          this.fields.values.position = -1;
          break;
        default:
          // Nothing to do here
          break;
      }
    },
    resetToDefaults() {
      this.positionMode = POSITION_MODES[0];
      this.fields.values.tenant = null;
      this.fields.values.list = false;
      this.fields.values.position = null;
      this.fields.errors.tenant = [];
      this.fields.errors.list = [];
      this.fields.errors.position = [];
    },
  },
  i18n: {
    messages: {
      de: {
        title: 'Publikation verwalten',
        fields: {
          list: 'Sichtbar auf Listenseiten',
          positionMode: 'Positionierung',
        },
        positionModes: {
          none: 'Zufällig',
          top: 'Am Listenanfang',
          bottom: 'Am Listenende',
          custom: 'Benutzerdefiniert…',
        },
        validationErrors: {
          publicationTaken:
            'Das Angebot ist diesem Mandanten bereits zugeordnet',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// PublicationForm.vue?55c9e3e6